'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const CheckCircleIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M21.2001 11.3C21.2001 11.5 21.2001 11.7 21.2001 12C21.2001 17.1 17.1 21.2 12 21.2C6.90005 21.2 2.80005 17.1 2.80005 12C2.80005 6.89999 6.90005 2.79999 12 2.79999C13.9 2.79999 15.6 3.29999 17 4.29999M7.80005 11.7L11.1 15C11.3 15.2 11.7 15.2 11.9 15L21.4 5.49999",
        stroke: "currentColor"
      }
    )
  }
);
const VpCheckCircleIcon = forwardRef(CheckCircleIcon);

export { VpCheckCircleIcon as default };
